export default __webpack_public_path__ + "static/media/Icon2.43d0955f.png";